import { z } from 'zod';
import { DecimalLikeSchema, IsoDateTimeSchema, NullableUrlSchema, PaginationSchema, UuidSchema } from './common.js';
export const BancoMovimientoTipoSchema = z.enum(['ingreso', 'egreso']);
export const BancoSaldoSchema = z.object({
    id: UuidSchema,
    saldo: DecimalLikeSchema,
    createdAt: IsoDateTimeSchema.nullable(),
});
export const BancoHistoricosSchema = z.object({
    totalIngresos: DecimalLikeSchema,
    totalEgresos: DecimalLikeSchema,
});
export const BancoMovimientoSchema = z.object({
    id: UuidSchema,
    bancoId: UuidSchema,
    concepto: z.string().min(1).max(300),
    monto: DecimalLikeSchema,
    tipo: BancoMovimientoTipoSchema,
    observaciones: z.string().max(1000).nullable(),
    comprobanteUrl: NullableUrlSchema,
    createdAt: IsoDateTimeSchema.nullable(),
});
// A-2: a lista de movimientos é uma vista unificada — movimientos próprios do banco +
// transferencias com perna banco (retiro/depósito), estas read-only (origen).
export const BancoMovimientoOrigenSchema = z.enum(['movimiento', 'transferencia']);
export const BancoMovimientoMergedSchema = z.object({
    id: UuidSchema,
    concepto: z.string().min(1).max(300),
    monto: DecimalLikeSchema,
    tipo: BancoMovimientoTipoSchema,
    observaciones: z.string().max(1000).nullable(),
    comprobanteUrl: NullableUrlSchema,
    createdAt: IsoDateTimeSchema.nullable(),
    origen: BancoMovimientoOrigenSchema,
});
// bancoId resolve para a conta singleton (Banco Continental) no service.
export const CreateBancoMovimientoRequestSchema = z.object({
    concepto: z.string().min(1).max(300),
    monto: DecimalLikeSchema,
    tipo: BancoMovimientoTipoSchema,
    observaciones: z.string().max(1000).nullable().optional(),
    comprobanteUrl: z.string().url().max(1000).nullable().optional(),
});
export const UpdateBancoMovimientoRequestSchema = z.object({
    concepto: z.string().min(1).max(300).optional(),
    monto: DecimalLikeSchema.optional(),
    tipo: BancoMovimientoTipoSchema.optional(),
    observaciones: z.string().max(1000).nullable().optional(),
    comprobanteUrl: z.string().url().max(1000).nullable().optional(),
});
export const BancoMovimientoListQuerySchema = PaginationSchema.extend({
    tipo: BancoMovimientoTipoSchema.optional(),
    from: IsoDateTimeSchema.optional(),
    to: IsoDateTimeSchema.optional(),
});
//# sourceMappingURL=banco.js.map